module.exports = __webpack_public_path__ + "img/case1-bg.ed79d25b.png";